import { render } from "./newDeviceModal.vue?vue&type=template&id=5803d2f4"
import script from "./newDeviceModal.vue?vue&type=script&lang=js"
export * from "./newDeviceModal.vue?vue&type=script&lang=js"
script.render = render

export default script